import axiosInstance from "../../app/apiClient";
import { DataParam, RolesAdminService } from "../model/roles.model";


const getRolesData = () => axiosInstance.get(`api/v1/roles`);
const addRoles = (data: DataParam) => axiosInstance.post(`api/v1/roles`, data);
const updateRoles = (data: DataParam, id: number) => axiosInstance.put(`api/v1/roles/${id}`, data)
const removeRoles = (id: number) => axiosInstance.delete(`api/v1/roles/${id}`)
const getOneRoles = (id: number) => axiosInstance.get(`api/v1/roles/${id}`)
const rolesAdmin: RolesAdminService = {
    getRolesData,
    addRoles,
    updateRoles,
    removeRoles,
    getOneRoles
}
export default rolesAdmin;